export default{
    isFamilyRelationship : 'Is Family Relationship',
    familyRelationship : 'Family Relationship',
    maleBloodType: 'Male Blood Type',
    femaleBloodType: 'Female Blood Type',
    isRealizationOfMarriage: 'Is Realization Of Marriage',
    totalAgeOfMenAndWomen: 'Total Age Of Men And Women',
    genderDetermination: 'Gender Determination',
    historyOfPresentingComplaint: 'History Of Presenting Complaint',
    durationOfMarriage: 'Duration Of Marriage',
    infertility: 'Infertility',
    allergy: 'Allergy',
    addiction: 'Addiction',
    cycle: 'Cycle',
    irregular: 'Irregular',
    regular: 'Regular',
    duration: 'Duration(days)',
    interval: 'Interval',
    pain: 'Pain',
    heaviness: 'Heaviness',
    lmp: 'LMP',
    imb: 'IMB',
    pCB: 'PCB',
    contraceptive: 'Contraceptive',
    weight: 'Weight',
    height: 'Height(CM)',
    bmi: 'BMI',
    low: 'Low',
    average: 'Average',
    high: 'High',
    numberOfChildren: 'Number Of Children',
    freezer:'Freezer',
    delete:'Delete',
    donate: 'Donate',
    child: 'child',
}